/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState, useContext } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import WebpageEditContext from "components/webpage-selector/context/index";
import { Logger } from "cms/utils/log/logger";

const WebpageBannerImage = () => {

    const { token } = useAuth();
    const [image, setImage] = useState(null);

    const webpageEditContext = useContext(WebpageEditContext);
    const selectedData = webpageEditContext?.selectedData;
    const banner = selectedData?.image;

    useEffect(() => {
        const fetchImage = async () => {
            if (banner) {
                const current_image = await SimpliCityAdminSDK.image.findOne(token, banner);
                if (current_image && current_image.guid) {
                    setImage(current_image);
                } else {
                    Logger.warn(`Could not load CoverImageThumbnail... ${current_image.guid}`);
                }
            } else {
                setImage(undefined);
            }
        };
        fetchImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [banner]);

    return (
        <div className='webpage-banner-image'>
            <img src={image?.url} alt={image?.title} />
        </div>
    );
};

export { WebpageBannerImage };
